/* eslint-disable */
import * as React from 'react';
import {
  Avatar, Badge, Box, Button, Collapse, Divider, Flex, FormControl, FormLabel, HStack, Icon,
  IconButton, Input, InputGroup, InputRightElement, Modal, ModalBody, ModalCloseButton,
  ModalContent, ModalFooter, ModalOverlay, Select, SimpleGrid, Stack, Table, Tbody, Td,
  Text, Th, Thead, Tooltip, Tr, useColorModeValue, useDisclosure, useToast,
} from '@chakra-ui/react';
import {
  AutoComplete, AutoCompleteInput, AutoCompleteItem, AutoCompleteList,
} from '@choc-ui/chakra-autocomplete';
import {
  ColumnFiltersState, PaginationState, createColumnHelper, flexRender,
  getCoreRowModel, getFacetedMinMaxValues, getFacetedRowModel, getFacetedUniqueValues,
  getFilteredRowModel, getPaginationRowModel, getSortedRowModel, useReactTable,
} from '@tanstack/react-table';
import { useForm } from 'react-hook-form';
import { MdBadge, MdCancel, MdChevronLeft, MdChevronRight, MdDoneAll, MdEmail, MdFilterList, MdLock, MdLoupe, MdPerson, MdRefresh, MdVisibility, MdVisibilityOff } from 'react-icons/md';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';

type RowObj = {
  id: number;
  NombreCompleto: string;
  Seccion: string;
  Casillas: string;
  CorreoElectronico: string;
  Bloqueado: boolean;
  createdAt: string;
  Tipo: string;
};

export default function SearchTableOrders(props: { tableData: any }) {
  const { tableData } = props;
  const toast = useToast();
  const filterBg = useColorModeValue('gray.50', 'navy.900');
  const textColor = useColorModeValue('navy.700', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const brandColor = useColorModeValue('brand.500', 'brand.400');
  const rowHover = useColorModeValue('gray.50', 'whiteAlpha.50');

  const { isOpen: isOpenNuevo, onOpen: onOpenNuevo, onClose: onCloseNuevo } = useDisclosure();
  const { isOpen: isOpenDetalle, onOpen: onOpenDetalle, onClose: onCloseDetalle } = useDisclosure();
  const [showFilters, setShowFilters] = React.useState(false);
  const [seccionFilter, setSeccionFilter] = React.useState('');
  const [fechaDesde, setFechaDesde] = React.useState('');
  const [fechaHasta, setFechaHasta] = React.useState('');
  const [selectedPersonal, setSelectedPersonal] = React.useState<RowObj | null>(null);
  const [updatingId, setUpdatingId] = React.useState<number | null>(null);

  const activeFilters = [!!seccionFilter, !!(fechaDesde || fechaHasta)].filter(Boolean).length;
  const resetFilters = () => { setSeccionFilter(''); setFechaDesde(''); setFechaHasta(''); };

  const [data, setData] = React.useState<RowObj[]>(() => [...tableData]);
  const [globalFilter, setGlobalFilter] = React.useState('');
  const [columnFilters, setColumnFilters] = React.useState<ColumnFiltersState>([]);
  const [{ pageIndex, pageSize }, setPagination] = React.useState<PaginationState>({ pageIndex: 0, pageSize: 8 });
  const pagination = React.useMemo(() => ({ pageIndex, pageSize }), [pageIndex, pageSize]);

  const filteredData = React.useMemo(() => data.filter((r) => {
    if (seccionFilter && r.Seccion !== seccionFilter) return false;
    if (fechaDesde || fechaHasta) {
      const d = r.createdAt ? new Date(r.createdAt) : null;
      if (!d) return false;
      if (fechaDesde && d < new Date(fechaDesde)) return false;
      if (fechaHasta && d > new Date(fechaHasta + 'T23:59:59')) return false;
    }
    return true;
  }), [data, seccionFilter, fechaDesde, fechaHasta]);

  const uniqueSecciones = React.useMemo(() => [...new Set(data.map((r) => r.Seccion).filter(Boolean))].sort(), [data]);

  const { handleSubmit, register, reset, formState: { isSubmitting } } = useForm();
  const [showPass, setShowPass] = React.useState(false);
  const [seccionSelec, setSeccionSelec] = React.useState('');
  const [secciones, setSecciones] = React.useState<any[]>([]);

  React.useEffect(() => {
    fetch(process.env.REACT_APP_URL_SERVER + '/secciones', { credentials: 'include' }).then(r => r.json()).then(setSecciones).catch(() => {});
  }, []);

  const refreshTable = async () => {
    const d = await fetch(process.env.REACT_APP_URL_SERVER + '/personal', { credentials: 'include' }).then(r => r.json()).catch(() => null);
    if (d) setData(d);
  };

  const onSubmitNuevo = async (values: any) => {
    const fd = new FormData();
    for (const k in values) fd.append(k, values[k]);
    if (seccionSelec) {
      const p = JSON.parse(seccionSelec);
      fd.append('Seccion', p.label);
    }
    const res = await fetch(process.env.REACT_APP_URL_SERVER + '/new_personal', { method: 'POST', body: fd, credentials: 'include' });
    if (res.ok) {
      toast({ title: 'Personal registrado', status: 'success', duration: 3000 });
      reset();
      setSeccionSelec('');
      onCloseNuevo();
      await refreshTable();
      return;
    }
    toast({ title: 'Error al guardar', status: 'error', duration: 3000 });
  };

  const updatePersonalStatus = async (id: number, bloqueado: boolean) => {
    setUpdatingId(id);
    try {
      const fd = new FormData();
      fd.append('id', String(id));
      fd.append('Bloqueado', String(bloqueado));

      const res = await fetch(process.env.REACT_APP_URL_SERVER + '/personal_mod', {
        method: 'POST',
        body: fd,
        credentials: 'include',
      });

      if (!res.ok) throw new Error(await res.text());

      setData((current) => current.map((item) => item.id === id ? { ...item, Bloqueado: bloqueado } : item));
      setSelectedPersonal((current) => current && current.id === id ? { ...current, Bloqueado: bloqueado } : current);

      toast({
        title: bloqueado ? 'Personal bloqueado' : 'Personal activado',
        status: 'success',
        duration: 2500,
      });
    } catch (error) {
      toast({
        title: 'Error al actualizar',
        description: error instanceof Error ? error.message : 'No se pudo cambiar el estatus.',
        status: 'error',
        duration: 3000,
      });
    } finally {
      setUpdatingId(null);
    }
  };

  const columnHelper = createColumnHelper<RowObj>();
  const columns = [
    columnHelper.accessor('NombreCompleto', {
      id: 'nombre',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">NOMBRE</Text>,
      cell: (info) => <Box><Text color={textColor} fontWeight="600" fontSize="sm">{info.getValue()}</Text><Text color="gray.400" fontSize="xs">{info.row.original.CorreoElectronico}</Text></Box>,
    }),
    columnHelper.accessor('Seccion', {
      id: 'seccion',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">SECCION</Text>,
      cell: (info) => <Badge colorScheme="purple" fontSize="xs" borderRadius="md" px="2">{info.getValue()}</Badge>,
    }),
    columnHelper.accessor('Casillas', {
      id: 'casillas',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">CASILLAS</Text>,
      cell: (info) => <Text color={textColor} fontSize="sm">{info.getValue() || 'Sin asignar'}</Text>,
    }),
    columnHelper.accessor('Bloqueado', {
      id: 'estatus',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">ESTATUS</Text>,
      cell: (info) => <Badge colorScheme={info.getValue() ? 'red' : 'green'} fontSize="xs" borderRadius="full" px="3" py="1">{info.getValue() ? 'Bloqueado' : 'Activo'}</Badge>,
    }),
    columnHelper.accessor('createdAt', {
      id: 'registro',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">REGISTRO</Text>,
      cell: (info) => {
        const v = info.getValue();
        return <Text color="gray.500" fontSize="xs">{v ? new Date(v).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' }) : '-'}</Text>;
      },
    }),
    columnHelper.accessor('id', {
      id: 'actions',
      header: () => <Text fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" fontWeight="700">ACCIONES</Text>,
      cell: (info) => (
        <HStack spacing="2px">
          <Tooltip label="Ver detalle"><IconButton aria-label="detalle" size="sm" variant="ghost" colorScheme="gray" icon={<Icon as={MdLoupe} h="18px" w="18px" />} onClick={() => { setSelectedPersonal(info.row.original); onOpenDetalle(); }} /></Tooltip>
          <Tooltip label="Activar"><IconButton aria-label="activar" size="sm" variant="ghost" colorScheme="green" icon={<Icon as={MdDoneAll} h="18px" w="18px" />} isDisabled={!info.row.original.Bloqueado || updatingId === info.getValue()} isLoading={updatingId === info.getValue() && info.row.original.Bloqueado} onClick={() => updatePersonalStatus(info.getValue(), false)} /></Tooltip>
          <Tooltip label="Bloquear"><IconButton aria-label="bloquear" size="sm" variant="ghost" colorScheme="red" icon={<Icon as={MdCancel} h="18px" w="18px" />} isDisabled={info.row.original.Bloqueado || updatingId === info.getValue()} isLoading={updatingId === info.getValue() && !info.row.original.Bloqueado} onClick={() => updatePersonalStatus(info.getValue(), true)} /></Tooltip>
        </HStack>
      ),
    }),
  ];

  const table = useReactTable({
    data: filteredData, columns,
    state: { columnFilters, globalFilter, pagination },
    onPaginationChange: setPagination, onColumnFiltersChange: setColumnFilters, onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(), getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(), getPaginationRowModel: getPaginationRowModel(),
    getFacetedRowModel: getFacetedRowModel(), getFacetedUniqueValues: getFacetedUniqueValues(), getFacetedMinMaxValues: getFacetedMinMaxValues(),
  });
  const createPages = (n: number) => Array.from({ length: n }, (_, i) => i + 1);

  return (
    <Flex direction="column" w="100%" overflowX={{ sm: 'scroll', lg: 'hidden' }}>
      <Flex align="center" justify="space-between" w="100%" px="22px" mb="16px" flexWrap="wrap" gap="10px">
        <DebouncedInput value={globalFilter ?? ''} onChange={(v) => setGlobalFilter(String(v))} placeholder="Buscar personal..." />
        <HStack spacing="8px">
          <Tooltip label="Actualizar"><IconButton aria-label="refresh" size="md" variant="outline" icon={<Icon as={MdRefresh} h="18px" w="18px" />} onClick={refreshTable} /></Tooltip>
          <Button variant="outline" fontSize="sm" leftIcon={<Icon as={MdFilterList} />} onClick={() => setShowFilters(v => !v)} position="relative">
            Filtros{activeFilters > 0 && <Badge colorScheme="brand" borderRadius="full" position="absolute" top="-6px" right="-6px" fontSize="10px" minW="18px" h="18px" display="flex" alignItems="center" justifyContent="center">{activeFilters}</Badge>}
          </Button>
          <Button variant="brand" fontSize="sm" fontWeight="500" onClick={onOpenNuevo}>+ Nuevo Personal</Button>
        </HStack>
      </Flex>

      <Collapse in={showFilters} animateOpacity>
        <Box mx="22px" mb="16px" p="16px" bg={filterBg} borderRadius="12px" border="1px solid" borderColor={borderColor}>
          <Text fontSize="sm" fontWeight="700" color={textColor} mb="14px">Filtros avanzados</Text>
          <SimpleGrid columns={{ base: 1, md: 2 }} gap="16px">
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">SECCION</FormLabel>
              <Select size="sm" borderRadius="8px" value={seccionFilter} onChange={(e) => { setSeccionFilter(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }}>
                <option value="">Todas</option>
                {uniqueSecciones.map(s => <option key={s} value={s}>{s}</option>)}
              </Select>
            </Box>
            <Box>
              <FormLabel fontSize="xs" fontWeight="600" color="gray.500" mb="6px">FECHA DE REGISTRO</FormLabel>
              <HStack spacing="8px">
                <Input size="sm" type="date" borderRadius="8px" value={fechaDesde} onChange={(e) => { setFechaDesde(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
                <Text fontSize="xs" color="gray.400">al</Text>
                <Input size="sm" type="date" borderRadius="8px" value={fechaHasta} onChange={(e) => { setFechaHasta(e.target.value); setPagination(p => ({ ...p, pageIndex: 0 })); }} />
              </HStack>
            </Box>
          </SimpleGrid>
          <Flex mt="14px" justify="flex-end"><Button size="sm" variant="ghost" colorScheme="red" onClick={resetFilters}>Limpiar filtros</Button></Flex>
        </Box>
      </Collapse>
      {activeFilters > 0 && <Text px="22px" mb="8px" fontSize="xs" color="gray.500">Mostrando <strong>{filteredData.length}</strong> de {data.length} registros</Text>}

      <Modal isOpen={isOpenNuevo} onClose={() => { reset(); setSeccionSelec(''); setShowPass(false); onCloseNuevo(); }} size="2xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
          <Box bg="brand.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdBadge} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Registrar Nuevo Personal</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>

          <form onSubmit={handleSubmit(onSubmitNuevo)}>
            <ModalBody px={6} py={6}>
              <Flex justify="center" mb={6}>
                <Box position="relative">
                  <Avatar size="xl" bg="brand.100" icon={<Icon as={MdPerson} w={10} h={10} color="brand.500" />} />
                  <Box position="absolute" bottom={0} right={0} bg="brand.500" borderRadius="full" p="5px" border="2px solid white">
                    <Icon as={MdBadge} color="white" w={3} h={3} />
                  </Box>
                </Box>
              </Flex>

              <HStack mb={3}>
                <Icon as={MdPerson} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">Informacion Personal</Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 2 }} gap={4} mb={5}>
                <FField label="Nombre Completo">
                  <Input placeholder="Juan Perez Garcia" variant="filled" borderRadius="lg" _focus={{ bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }} {...register('NombreCompleto', { required: true })} />
                </FField>
                <FField label="Correo Electronico">
                  <InputGroup>
                    <Input type="email" placeholder="juan@correo.com" variant="filled" borderRadius="lg" _focus={{ bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }} {...register('CorreoElectronico', { required: true })} />
                    <InputRightElement pointerEvents="none"><Icon as={MdEmail} color="gray.400" /></InputRightElement>
                  </InputGroup>
                </FField>
              </SimpleGrid>

              <HStack mb={3}>
                <Icon as={MdLock} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">Acceso al Sistema</Text>
                <Divider />
              </HStack>

              <Box mb={5}>
                <FField label="Contrasena">
                  <InputGroup>
                    <Input type={showPass ? 'text' : 'password'} placeholder="********" variant="filled" borderRadius="lg" _focus={{ bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }} {...register('Password', { required: true })} />
                    <InputRightElement>
                      <IconButton aria-label={showPass ? 'Ocultar' : 'Mostrar'} size="sm" variant="ghost" icon={<Icon as={showPass ? MdVisibilityOff : MdVisibility} h="18px" w="18px" color="gray.400" />} onClick={() => setShowPass(v => !v)} />
                    </InputRightElement>
                  </InputGroup>
                </FField>
              </Box>

              <HStack mb={3}>
                <Icon as={MdBadge} color="brand.500" w={4} h={4} />
                <Text fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="brand.500">Asignacion Electoral</Text>
                <Divider />
              </HStack>

              <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                <FField label="Seccion Electoral">
                  <AutoComplete openOnFocus onChange={(_k: any, vals: any) => setSeccionSelec(JSON.stringify(vals))}>
                    <AutoCompleteInput variant="filled" borderRadius="lg" placeholder="Selecciona una Seccion" required _focus={{ bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }} />
                    <AutoCompleteList maxH="300px" overflowY="auto">
                      {secciones.map((s: any) => (
                        <AutoCompleteItem key={`sec-${s.id}`} label={`${s.Municipio} - ${s.Seccion} (${s.Tipo})`} value={s.id}>
                          <Box>
                            <Text fontWeight="bold">{s.Municipio}</Text>
                            <Text fontSize="sm" color="gray.500">Sección {s.Seccion} - {s.Tipo}</Text>
                          </Box>
                        </AutoCompleteItem>
                      ))}
                    </AutoCompleteList>
                  </AutoComplete>
                </FField>
                <FField label="Casillas Asignadas">
                  <Input placeholder="Casilla 1, Casilla 2" variant="filled" borderRadius="lg" _focus={{ bg: 'white', borderColor: 'brand.500', boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)' }} {...register('Casillas')} />
                </FField>
              </SimpleGrid>
            </ModalBody>
            <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4}>
              <Button variant="ghost" borderRadius="xl" onClick={() => { reset(); setSeccionSelec(''); setShowPass(false); onCloseNuevo(); }}>Cancelar</Button>
              <Button colorScheme="brand" type="submit" isLoading={isSubmitting} borderRadius="xl" px={8} leftIcon={<Icon as={MdBadge} />}>Registrar Personal</Button>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>

      <Modal isOpen={isOpenDetalle} onClose={onCloseDetalle} size="xl" scrollBehavior="inside" motionPreset="slideInBottom">
        <ModalOverlay backdropFilter="blur(4px)" bg="blackAlpha.400" />
        <ModalContent borderRadius="2xl" overflow="hidden" mx={4}>
          <Box bg="blue.500" px={6} py={4}>
            <HStack justify="space-between" align="center">
              <HStack gap={3}>
                <Icon as={MdPerson} color="white" w={5} h={5} />
                <Text color="white" fontWeight="700" fontSize="lg">Detalle de Personal</Text>
              </HStack>
              <ModalCloseButton position="static" color="white" _hover={{ bg: 'whiteAlpha.300' }} borderRadius="lg" />
            </HStack>
          </Box>
          <ModalBody px={6} py={5}>
            {selectedPersonal && (
              <Stack gap="14px">
                <Box>
                  <Text color={textColor} fontWeight="700" fontSize="lg">{selectedPersonal.NombreCompleto}</Text>
                  <Text color="gray.500" fontSize="sm">{selectedPersonal.CorreoElectronico}</Text>
                </Box>
                <SimpleGrid columns={{ base: 1, md: 2 }} gap={4}>
                  <FField label="Estatus">
                    <Badge colorScheme={selectedPersonal.Bloqueado ? 'red' : 'green'} fontSize="sm" borderRadius="full" px="3" py="1">
                      {selectedPersonal.Bloqueado ? 'Bloqueado' : 'Activo'}
                    </Badge>
                  </FField>
                  <FField label="Tipo">
                    <Text color={textColor} fontSize="sm">{selectedPersonal.Tipo || 'Personal'}</Text>
                  </FField>
                  <FField label="Seccion">
                    <Text color={textColor} fontSize="sm">{selectedPersonal.Seccion || 'Sin asignar'}</Text>
                  </FField>
                  <FField label="Casillas">
                    <Text color={textColor} fontSize="sm">{selectedPersonal.Casillas || 'Sin asignar'}</Text>
                  </FField>
                  <FField label="Registro">
                    <Text color={textColor} fontSize="sm">{selectedPersonal.createdAt ? new Date(selectedPersonal.createdAt).toLocaleString('es-MX') : 'Sin fecha'}</Text>
                  </FField>
                </SimpleGrid>
              </Stack>
            )}
          </ModalBody>
          <ModalFooter borderTop="1px solid" borderColor="gray.100" gap={3} px={6} py={4}>
            <Button variant="ghost" borderRadius="xl" onClick={onCloseDetalle}>Cerrar</Button>
            {selectedPersonal && (
              <Button colorScheme={selectedPersonal.Bloqueado ? 'green' : 'red'} borderRadius="xl" isLoading={updatingId === selectedPersonal.id} onClick={() => updatePersonalStatus(selectedPersonal.id, !selectedPersonal.Bloqueado)}>
                {selectedPersonal.Bloqueado ? 'Activar' : 'Bloquear'}
              </Button>
            )}
          </ModalFooter>
        </ModalContent>
      </Modal>

      <Table variant="simple" color="gray.500" mb="24px">
        <Thead>{table.getHeaderGroups().map(hg => (<Tr key={hg.id}>{hg.headers.map(h => (<Th pe="10px" borderColor={borderColor} key={h.id} colSpan={h.colSpan}>{h.isPlaceholder ? null : (<Flex justify="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }} color="gray.400" cursor={h.column.getCanSort() ? 'pointer' : 'default'} onClick={h.column.getToggleSortingHandler()}>{flexRender(h.column.columnDef.header, h.getContext())}</Flex>)}</Th>))}</Tr>))}</Thead>
        <Tbody>
          {table.getRowModel().rows.length === 0 ? (<Tr><Td colSpan={columns.length} textAlign="center" py="40px" color="gray.400">Sin registros</Td></Tr>) :
            table.getRowModel().rows.map(row => (<Tr key={row.id} _hover={{ bg: rowHover }}>{row.getVisibleCells().map(cell => (<Td key={cell.id} fontSize={{ sm: '14px' }} minW={{ sm: '120px', md: 'auto' }} borderColor={borderColor} py="12px">{flexRender(cell.column.columnDef.cell, cell.getContext())}</Td>))}</Tr>))}
        </Tbody>
      </Table>

      <Flex w="100%" justify="space-between" px="20px" pt="10px" pb="5px">
        <Text fontSize="sm" color="gray.500" mb={{ sm: '24px', md: '0px' }}>{filteredData.length === 0 ? 'Sin registros' : `${pageSize * pageIndex + 1}-${Math.min(pageSize * (pageIndex + 1), filteredData.length)} de ${filteredData.length}`}</Text>
        <Stack direction="row" alignSelf="flex-end" spacing="4px" ms="auto">
          <Button variant="no-effects" onClick={() => table.previousPage()} disabled={!table.getCanPreviousPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanPreviousPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}><Icon as={MdChevronLeft} w="16px" h="16px" color={textColor} /></Button>
          {createPages(table.getPageCount()).map((p, i) => (<Button key={i} variant="no-effects" onClick={() => table.setPageIndex(p - 1)} w="40px" h="40px" borderRadius="50%" bg={p === pageIndex + 1 ? brandColor : 'transparent'} border={p === pageIndex + 1 ? 'none' : '1px solid lightgray'} _hover={p === pageIndex + 1 ? { opacity: '0.7' } : { bg: 'whiteAlpha.100' }}><Text fontSize="sm" color={p === pageIndex + 1 ? '#fff' : textColor}>{p}</Text></Button>))}
          <Button variant="no-effects" onClick={() => table.nextPage()} disabled={!table.getCanNextPage()} w="40px" h="40px" borderRadius="50%" bg="transparent" border="1px solid" borderColor={borderColor} display={table.getCanNextPage() ? 'flex' : 'none'} _hover={{ opacity: '0.7' }}><Icon as={MdChevronRight} w="16px" h="16px" color={textColor} /></Button>
        </Stack>
      </Flex>
    </Flex>
  );
}

function FField({ label, children }: { label: string; children: React.ReactNode }) {
  return (
    <FormControl>
      <FormLabel fontSize="xs" fontWeight="700" textTransform="uppercase" letterSpacing="wide" color="gray.500" mb={1}>{label}</FormLabel>
      {children}
    </FormControl>
  );
}

function DebouncedInput({ value: iv, onChange, debounce = 500, ...props }: { value: string | number; onChange: (v: string | number) => void; debounce?: number } & Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'>) {
  const [value, setValue] = React.useState(iv);
  React.useEffect(() => { setValue(iv); }, [iv]);
  React.useEffect(() => { const t = setTimeout(() => onChange(value), debounce); return () => clearTimeout(t); }, [value]);
  return <SearchBar {...props} value={value} onChange={(e: any) => setValue(e.target.value)} h="44px" w={{ lg: '390px' }} borderRadius="16px" />;
}
